import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(5),
    border: `1px solid #DBDBDB`,
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  backgroundImageContainer: {
    width: "100%",
    height: "100%",
  },
}));

export default useStyles;
